module.exports = __webpack_public_path__ + "a68ce41d5da96a7a5d59461fe2ce1ae5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/ave_maria_mutual_funds.png
// module id = 1805
// module chunks = 0